// @flow
import React from 'react';
import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { MAX_OFFERS } from '../helpers';
import RenderTermLength from '../TermLengthField';
import messages from '../../messages';
import useIntl from '../../../../hooks/useIntl';

type Props = {
  termsDropDown: Array<Object>,
  disableFlags: Array<boolean>,
};

const OfferTermsRow = ({ termsDropDown, disableFlags }: Props) => {
  const intl = useIntl();
  return (
    <>
      {Array.from({ length: MAX_OFFERS }, (_, i) => i + 1).map((n) => {
        const offerLabel = intl.formatMessage(messages.offer);
        const label =
          n === 1 ? `${offerLabel} 1 *` : `${offerLabel} ${n} (Optional)`;
        return (
          <RenderTermLength
            key={`offer${n}TermId`}
            fieldName={`offer${n}TermId`}
            termsDropDown={termsDropDown}
            label={label}
            disable={disableFlags[n - 1]}
          />
        );
      })}
      <Box sx={{ width: 40, flexShrink: 0 }} />
    </>
  );
};

export default OfferTermsRow;
